import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

interface ServicesCardProps {
  image: string;
  title: string;
  description: string;
  buttonText: string;
  onClick: () => void;
}

const StyledCard = styled(Card)(() => ({
  maxWidth: 500,
  borderRadius: '16px',
  transition: "transform 0.2s, box-shadow 0.2s",
  display: 'flex', // Use flex display for layout
  flexDirection: 'row', // Align items in a row
  overflow: 'hidden', // Prevent overflow
  // "&:hover": {
  //   transform: "scale(1.05)",
  //   boxShadow: theme.shadows[8],
  // },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '6px',
  margin: theme.spacing(0, 0),
  marginBottom: '9px',
}));

export default function ServicesCard({
  image,
  title,
  description,
  buttonText,
  onClick,
}: ServicesCardProps) {
  return (
    <StyledCard>
      {/* Image section */}
      <CardMedia component="img" alt={title} image={image} sx={{ width: '30%', height: 'auto' }} />

      {/* Content section */}
      <CardContent sx={{ padding: '16px' }}>
        <Typography gutterBottom variant="h6" component="div" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
          {description}
        </Typography>
        <CardActions sx={{ justifyContent: 'flex-start', paddingTop: '8px' }}>
          <StyledButton size="small" variant="contained" onClick={onClick} sx={{ bgcolor: 'primary.main', color: 'white' }}>
            {buttonText}
          </StyledButton>
          <StyledButton size="small" color="primary">
            Learn More
          </StyledButton>
        </CardActions>
      </CardContent>
    </StyledCard>
  );
}
